// extracted by mini-css-extract-plugin
export default {"header":"mP-z","isActive":"nP-z"};